import { ACSConfig, ACSUpdateConfig } from './ACSTypes';

export const ACS_CONFIG: ACSConfig = {
  version: 1,
} as const;

export const ACS_UPDATE_CONFIG: ACSUpdateConfig = {
  // How many updates do we fetch at once when fetching updates - if there are more updates, we will fetch again until we have caught up (returned data is always complete to the requested endInclusive offset - even if that means multiple fetches)
  maxUpdatesToFetch: 100,
  // Timeout in milliseconds for receiving the first element from the WebSocket stream when reading the ACS - if this timeout is reached before the first element is returned, we fall back to HTTP
  // lower values will make the UI more responsive in case of problems, but may lead to unnecessary fallbacks
  wsTimeoutBeforeFirstElement: 600000,
};

// Config attached to window for easier debugging / live configuration via browser console
/* eslint-disable */
if (typeof window !== 'undefined') {
  (window as any)['ACS_UPDATE_CONFIG'] = ACS_UPDATE_CONFIG;
}
/* eslint-enable */
